import React from 'react';
import { Helmet } from 'react-helmet-async';
import '../../styles/awesome-theme.css';
import AwesomeHero from '../../components/awesome/AwesomeHero';
import SocialProofStats from '../../components/awesome/SocialProofStats';
import CourseCards from '../../components/awesome/CourseCards';
import TeachersGrid from '../../components/awesome/TeachersGrid';
import TestimonialsCaseStudy from '../../components/awesome/TestimonialsCaseStudy';
import PricingComparison from '../../components/awesome/PricingComparison';
import FAQAccordion from '../../components/awesome/FAQAccordion';
import ContactSection from '../../components/ContactSection';
import AwesomeFooter from '../../components/awesome/AwesomeFooter';

const AwesomeHomePage: React.FC = () => {
  return (
    <div className="awesome-page">
      <Helmet>
        <title>Sigma Study - Zbuduj Pewnosc Siebie w Matematyce | Korepetycje Online</title>
        <meta name="description" content="Dolacz do ponad 500 uczniow, ktorzy osiagneli sukces na maturze. 98% zdawalnosc, +35 punktow sredni wzrost wynikow. Pierwsza lekcja gratis." />
        <link rel="canonical" href="https://sigmastudy.pl/awesome" />
      </Helmet>

      <AwesomeHero />
      <SocialProofStats />
      <CourseCards />
      <TeachersGrid />
      <TestimonialsCaseStudy />
      <PricingComparison />
      <FAQAccordion />
      <ContactSection />
      <AwesomeFooter />
    </div>
  );
};

export default AwesomeHomePage;
